import _get from 'lodash/get';

import { JSON_MIME_TYPE, JSON_EXTENSION } from '../../../PartialPage/PartialPage.constants';

export function isJsonFile(file) {
  const arr = file.name.split('.');
  return arr[arr.length - 1] === JSON_EXTENSION && _get(file, 'type') === JSON_MIME_TYPE;
}
